export default "__VITE_PUBLIC_ASSET__3cd07590__"